module.exports = __webpack_public_path__ + "static/media/Bitmap.a371c15f.png";